import React from "react";
import { AgentActivityTimeline } from "./AgentActivityTimeline";

/**
 * Backward compatibility wrapper delegating to AgentActivityTimeline.
 */
export const ReasoningStepsAccordion = (props) => {
  return <AgentActivityTimeline {...props} />;
};

export default ReasoningStepsAccordion;
